import React from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../Componentes/Basicos/LVGridDetalle";
import { TextArea } from "devextreme-react";

class VEN_Cotizaciones_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      globalUsaArticulosConPresentacion: true,
      globalUsaArticulosConTamano: true,
      globalUsaArticulosConUnidadDeMedida: true,
    };
  }

  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { VEN_Cotizaciones_Cabecera: { function_VEN_Cotizaciones_Cabecera_Leer } } = require('neftis7_apicaller');
      const resultData = await function_VEN_Cotizaciones_Cabecera_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  getDataParametros = async () => {
    try {
      const { Varios: { TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
      const { Varios: { ObtieneParametros } } = require('neftis7_apicaller');
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      this.state.globalUsaArticulosConPresentacion = globalUsaArticulosConPresentacionLocal
      this.state.globalUsaArticulosConTamano = globalUsaArticulosConTamanoLocal
      this.state.globalUsaArticulosConUnidadDeMedida = globalUsaArticulosConUnidadDeMedidaLocal

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.IdPedido)
    this.getDataParametros()
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loadingItems ? null : (
          <div style={{ display: "flex", gap: "20px" }}>
            {this.state.data && this.state.data.Detalles && this.state.data.Detalles.length > 0 ? (
              <div style={{ flex: 1 }}>
                <LVGridDetalle
                  dataSource={this.state.data.Detalles}
                  Titulo="Items"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                  <Column caption="Artículo" alignment="Center">
                    <Column caption="Código" dataField="CodigoArticulo" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Observaciones" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Presentación" alignment="Center" visible={this.state.globalUsaArticulosConPresentacion}>
                    <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ART_Presentaciones_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Tamaño" alignment="Center" visible={this.state.globalUsaArticulosConTamano}>
                    <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ART_Tamanos_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Unidad de Medida" alignment="Center" visible={this.state.globalUsaArticulosConUnidadDeMedida}>
                    <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ART_UnidadesMedida_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Cantidades" alignment="Center">
                    <Column caption="Pedida" dataField="Cantidad" width="70" alignment="Right" dataType="number" />
                    <Column caption="Facturada" dataField="CantidadFacturada" width="70" alignment="Right" dataType="number" />
                    <Column caption="Remitida" dataField="CantidadRemitida" width="70" alignment="Right" dataType="number" />
                  </Column>

                  <Column caption="Importes" alignment="Center">
                    <Column caption="Neto" dataField="ImporteNeto" width="100" alignment="Right" dataType="number" format="currency" />
                    <Column caption="I.V.A." dataField="ImporteIVA" width="100" alignment="Right" dataType="number" format="currency" />
                    <Column caption="Descuentos" dataField="ImporteDescuentos" width="100" alignment="Right" dataType="number" format="currency" />
                    <Column caption="Recargos" dataField="ImporteRecargos" width="100" alignment="Right" dataType="number" format="currency" />
                  </Column>

                  <Column caption="Ubicación" alignment="Center">
                    <Column caption="Código" dataField="CodigoUbicacionIngreso" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ZON_Ubicaciones_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                </LVGridDetalle>
              </div>
            ) : null}

            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "20px" }}>
              {this.state.data && this.state.data.RelacionesPedidosDocsVentaResult && this.state.data.RelacionesPedidosDocsVentaResult.length > 0 ? (

                <LVGridDetalle
                  dataSource={this.state.data.RelacionesPedidosDocsVentaResult}
                  Titulo="Docs. Venta"
                >
                  <Column caption="Código" dataField="IdDocVenta" width="80" alignment="Right" dataType="number" />
                  <Column caption="Documento" dataField="FENumeroFantasia" width="120" alignment="Left" dataType="string" />
                </LVGridDetalle>
              ) : null}

              {this.state.data && this.state.data.RelacionesPedidosRemitosResult && this.state.data.RelacionesPedidosRemitosResult.length > 0 ? (

                <LVGridDetalle
                  dataSource={this.state.data.RelacionesPedidosRemitosResult}
                  Titulo="Remitos"
                >
                  <Column caption="Código" dataField="IdRemito" width="80" alignment="Right" dataType="number" />
                  <Column caption="Documento" dataField="NumeroFantasia" width="120" alignment="Left" dataType="string" />
                </LVGridDetalle>

              ) : null}

              {this.state.data && this.state.data.Concepto ? (
                <>
                  <span style={{ fontWeight: "bold" }}>Concepto</span>
                  <TextArea defaultValue={this.state.data.Concepto} width={200} readOnly={true} />
                </>
              ) : null}

              {this.state.data && this.state.data.Observaciones ? (
                <>
                  <span style={{ fontWeight: "bold" }}>Observaciones</span>
                  <TextArea defaultValue={this.state.data.Observaciones} width={200} readOnly={true} />
                </>
              ) : null}
            </div>
          </div>
        )
        }
      </React.Fragment>
    );
  }
}

export default VEN_Cotizaciones_Detalle;
